<template>
    <vue-dropzone
        ref="InterDropZoneImport"
        id="InterDropZoneImport"
        :useCustomSlot="true"
        :options="dropzoneOptions"
        v-on:vdropzone-success="uploaded"
        v-on:vdropzone-file-added="getPresignedUrl"
        v-on:vdropzone-error="handleError"
        v-on:vdropzone-sending="sendingFile"
    >
        <div class="AdminMailingsForm-UploadAttachment-dropZone">
            <h3 class="UploadImportFile-title">
                Drag and drop to upload tickets!
            </h3>
            <div class="AdminMailingsForm-UploadAttachment-subtitle">
                ...or click to select a file from your computer
            </div>
        </div>
    </vue-dropzone>
</template>

<script>

    import vue2Dropzone from "vue2-dropzone";
    import {mapActions, mapGetters, mapMutations} from "vuex";

    export default {
        name: "AdminRequestUploadTicketDirectUpload",
        data() {
            return {
                fileToUpload: {},
                dropzoneOptions: {
                    url: process.env.VUE_APP_API_URL + 'test-url',
                    headers: {
                        accept: 'application/json'
                    },
                    params: {},
                    method: 'PUT',
                    autoProcessQueue: false,
                    uploadMultiple: false,
                    addRemoveLinks: true,
                    createImageThumbnails: false,
                    withCredentials: true,
                },

            }
        },

        components: {
            vueDropzone: vue2Dropzone
        },
        computed: {
            ...mapGetters(['adminRequestCurrent', 'accessToken']),

        },
        methods: {

            ...mapActions({
                adminRequestsgetPresignedUrl: 'adminRequestsgetPresignedUrl',
                adminRequestsStoreTickets: 'adminRequestsStoreTickets',
            }),

            ...mapMutations([
                'adminRequestsSetCurrent'
            ]),

            uploaded: function () {

                this.adminRequestsStoreTickets({
                    request: this.adminRequestCurrent,
                    file: this.fileToUpload
                })
                    .then(() => {
                        this.$bvToast.toast('Biglietti caricati correttamente', {
                            title: 'Success',
                            variant: 'success'
                        });
                    })
                    .catch(() => {
                        this.$bvToast.toast('File non caricato correttamente', {
                            title: 'Alert',
                            variant: 'warning'
                        });
                    })
            },

            getPresignedUrl: function (file) {
                this.fileToUpload = {
                    name: file.name,
                    size: file.size,
                    type: file.type,
                    path: ''
                };
                this.adminRequestsgetPresignedUrl({
                    request: this.adminRequestCurrent,
                    file: this.fileToUpload
                })
                    .then((data) => {
                        this.fileToUpload.name = data.filename;
                        this.fileToUpload.path = data.path;
                        this.$refs.InterDropZoneImport.setOption('url', data.postEndpoint);
                        this.$refs.InterDropZoneImport.setOption('headers', {
                            accept: 'application/json',
                            'Content-Type': this.fileToUpload.type
                        });

                        this.$refs.InterDropZoneImport.processQueue();
                    })
                    .catch(() => {
                        this.$bvToast.toast('Problemi nel caricamento dei biglietti', {
                            title: 'Alert',
                            variant: 'warning'
                        });
                    })
            },

            sendingFile: function(file, xhr) {
                const _send = xhr.send;
                xhr.send = function() {
                    _send.call(xhr, file);
                };
            },

            handleError: function () {
                this.$refs.InterDropZoneImport.removeAllFiles();
                this.response = null;
                this.file = null;
                this.fileToUpload = {};
                this.$bvToast.toast('File non caricato correttamente', {
                    title: 'Alert',
                    variant: 'warning'
                });
            },
        }
    }
</script>

<style scoped>

</style>
